module.exports = "/img/_/_/_/assets/images/creeper/battle/common//12.jpg?f30b9417ecc9351e60ecb359b3d994f2";